const my_profile = {
  viewMyClubSeacretProfile: "Ver Perfil do Meu ClubeSeacret", // translated
  viewMoreDetails: "Ver mais detalhes", // translated
  unverifiedEmail: "E-mail não verificado", // translated
  verifiedEmail: "E-mail verificado", // translated
  createdFrom: "Criado a partir de", // translated
  createdTo: "Criado até", // translated
  selectStatus: "Selecionar status...", // translated
  searchByTitle: "Pesquisar por título...", // translated
};

export default my_profile;
